<template>
  <div>
      <p class="goldenP"><img src="@/assets/blackStar.png" style="width: 14px; margin-top: -4px;" alt=""> {{text}}</p>
  </div>
</template>

<script>
export default {
  name: 'GoldenButton',
  props: {
      text: String,
  }
}
</script>

<style scoped>
.goldenP{
    background-image: linear-gradient(to right, #dacb68 , #9b7b23);
    border-radius: 5px;
    height: 45px;
    color: #212529;
    text-align: center;
    font-weight: bold;   
    margin-bottom: 10px; 
    padding-top: 5%;
    font-size: 14px;
    letter-spacing: 1px;
}
</style>
